/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolParkIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-park"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M9.45 18.9L4.17 18.9Q3.38 18.9 3.01 18.2Q2.65 17.5 3.08 16.85L5.75 12.8L5.75 12.8Q5.1 12.8 4.8 12.22Q4.5 11.65 4.88 11.13L10.93 2.45Q11.13 2.17 11.41 2.04Q11.7 1.9 12 1.9Q12.3 1.9 12.59 2.04Q12.88 2.17 13.07 2.45L19.13 11.13Q19.5 11.65 19.2 12.22Q18.9 12.8 18.25 12.8L18.25 12.8L20.93 16.85Q21.35 17.5 20.99 18.2Q20.63 18.9 19.82 18.9L14.55 18.9L14.55 21.68Q14.55 22.23 14.16 22.61Q13.78 23 13.22 23L10.78 23Q10.22 23 9.84 22.61Q9.45 22.23 9.45 21.68Z" fill={color} />
    </svg>
  );
}
